import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {Entry} from "contentful";
import * as contentful from "contentful";
import {RpcState} from "../../../util/RpcState";
import {getArticleCategory} from "../../../util/ContentUtil";
import {ArticlePreview} from "./ArticlePreview";
import {ActionButton} from "../../../util/UI/ActionButton";

type Props = {
  hasGoToWellnessLibraryButton: boolean,
}

/**
 * Used in the regular homepage and waitlist.
 */
export const ArticlePreviewSection = (props: Props) => {

  const navigate = useNavigate();

  const articleIds = ['6LiYNorhqaQCobCPcKzd7b', '6oPtpIlUpKAwTI5WUqWLEo', '5Cr0r3FgYNhKI8YegnJ9tK'];

  const [articles, setArticles] = useState<Entry[]>([]);

  const [rpcState, setRpcState] = useState<RpcState>({state: 'pending'});

  const client = contentful.createClient({
    space: 'zrbrzjug66a4',
    accessToken: '9QNFQ-iadIryADYUrJbiv1llDAUVJJ6iBdT80w9ZD_c'
  });

  useEffect(() => {
    client.getEntries({
      content_type: 'post',
      select: ['sys.id', 'fields.title', 'fields.coverImage', 'fields.articleCategories'],
      "sys.id[in]": articleIds
    }).then(resp => {
      setRpcState({state: 'success'})
      setArticles(resp.items);
    }).catch(e => {
      console.log('error', e);
      setRpcState({state: 'error'})
    })
  }, []);


  return (<div className="AppSection BeigeSection">
    <div className="AppSectionContent ArticlePreviewSection">

      <div className={'ArticlePreviewsContainer'}>

        {articles.map(article => {
          // @ts-ignore
          const coverImageUrl = article.fields.coverImage?.fields?.file?.url + '?w=400';
          return <ArticlePreview key={article.sys.id}
                                 link={`/library/article/${article.sys.id}`}
                                 imgSource={coverImageUrl}
                                 category={getArticleCategory(article)}
                                 title={article.fields.title as string}/>

        })}

        {rpcState.state == 'pending' && <>Loading...</>}
        {rpcState.state == 'error' && <>Error loading content</>}

      </div>

      {props.hasGoToWellnessLibraryButton && <div>
        <ActionButton orange extraStyles={{margin: 20, padding: '10px 54px'}}
                      onClick={() => navigate('/library')}>
          GO TO WELLNESS LIBRARY
        </ActionButton>
      </div>}

    </div>
  </div>);
}